import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import ShipmentLoadingForm from "./ShipmentLoadingComponents/ShipmentLoadingForm";

import { useGetShipmentLoadingDetailQuery, useUpdateShipmentLoadingMutation } from "store/services/shipmentLoadingApi";

import { useAppMeta } from "hooks";
const ShipmentLoadingEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment Loading", path: "/app/crm/shipment-loading/list" },
    { title: "Edit Shipment Loading" },
  ];

  // RTK Query
  const { data: shipmentLoadingDetail, isLoading: loadingShipmentLoading, error,
  } = useGetShipmentLoadingDetailQuery(id)

  const [updateShipmentLoading, { isLoading: updatingShipmentLoading }
  ] = useUpdateShipmentLoadingMutation();

  // methods
  const handleUpdateShipmentLoading = async (data) => {

    const _payload = data;

    delete _payload.disclaimers;

    try {
      await updateShipmentLoading({ ..._payload },).unwrap();
      toast.success("Shipment Loading successfully updated!");
      navigate(`/app/crm/shipment-loading/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Shipment Loading!"
      );
    }
  };

  useAppMeta("Edit Shipment Loading");
  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingShipmentLoading || updatingShipmentLoading}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ShipmentLoadingForm
          isBusy={loadingShipmentLoading || loadingShipmentLoading}
          shipmentLoadingDetail={shipmentLoadingDetail}
          onSubmit={handleUpdateShipmentLoading}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default ShipmentLoadingEditScreen